import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, ArrowRight } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CART_LINK, trackAddToCart } from '../lib/constants';
export function DynamicPricingOffer() {
  return <section className="w-full px-5 md:px-8 py-24 md:py-40 bg-base" data-id="element-48">
      <div className="max-w-4xl mx-auto text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-50">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink mb-6 leading-[1.1] tracking-tight" data-id="element-51">
            Empezá a sentirte mejor hoy.
          </h2>
          <p className="text-[17px] md:text-xl text-ink/80 max-w-2xl mx-auto leading-[1.75]" data-id="element-52">
            Acceso inmediato a MOVÉ SUAVE™ + 7 Bonos Premium.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] shadow-xl overflow-hidden max-w-2xl mx-auto border border-ink/5" data-id="element-53">
          <div className="bg-primary text-base py-4 px-6" data-id="element-54">
            <p className="font-semibold tracking-[0.2em] uppercase text-[11px] md:text-xs" data-id="element-55">
              Oferta Especial de Lanzamiento
            </p>
          </div>

          <div className="p-8 md:p-14" data-id="element-56">
            <div className="flex flex-col items-center justify-center gap-3 mb-10" data-id="element-57">
              <p className="text-ink/50 text-[17px] md:text-lg" data-id="element-58">
                Precio Regular: <PriceDisplay amountArs={74999} strikethrough data-id="element-59" />
              </p>
              <div className="flex items-baseline gap-3" data-id="element-60">
                <span className="text-2xl md:text-3xl font-medium text-ink" data-id="element-61">
                  HOY:
                </span>
                <span className="font-serif text-6xl md:text-8xl text-primary leading-[1.0] tracking-tight" data-id="element-62">
                  <PriceDisplay amountArs={14999} data-id="element-63" />
                </span>
              </div>
            </div>

            <a href={CART_LINK} onClick={() => trackAddToCart()} className="w-full inline-flex items-center justify-center gap-2 bg-ink text-base px-8 py-5 md:py-6 rounded-lg text-xl font-semibold tracking-wide hover:bg-ink/90 transition-all duration-300 hover:-translate-y-0.5 shadow-lg hover:shadow-xl mb-8" data-id="element-64">
              Quiero empezar a moverme suave <ArrowRight className="w-5 h-5" data-id="element-65" />
            </a>

            <div className="flex flex-col gap-4 text-[13px] md:text-sm text-ink/60" data-id="element-66">
              <p className="flex items-center justify-center gap-2" data-id="element-67">
                <Lock className="w-4 h-4" data-id="element-68" /> Pago 100% Seguro y Encriptado
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-69">
                <ShieldCheck className="w-4 h-4" data-id="element-70" /> Garantía de 60 Días "Ámalo o
                Déjalo"
              </p>
              <p className="mt-2" data-id="element-71">
                Acceso inmediato. Pago único. Sin suscripciones ocultas.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}